import { useHistory } from "react-router";
import DropDownIcon from "../../assets/svg/DropdownIcon";
import ButtonProps from "../../services/models/buttonProps.model";
import CustomText from "../atomic/CustomText";
import Button from "../organism/Button";
import ContextItemLoadingIndicator from "./LoadingIndicators/ContextItemLoadingIndicator";
import useProfile from "../../services/utils/custom hooks/useProfile";
import Selectors from "./Selectors";
import Divider from "../../assets/svg/Divider";

interface SubHeaderProps {
  title: string;
  customButtons?: ButtonProps[];
  showBackButton?: boolean;
  containerClass?: string;
  reDirect?: any;
  loading?: boolean;
  hideSubHeaderSelectors?: boolean;
  showButtonInSubheaderForMobile?: boolean;
  hideTitleAndRedirect?: boolean;
}

function SubHeader({
  title,
  customButtons,
  containerClass,
  showBackButton,
  reDirect,
  hideSubHeaderSelectors,
  loading,
  showButtonInSubheaderForMobile = false,
  hideTitleAndRedirect = false,
}: Readonly<SubHeaderProps>): JSX.Element {
  const history = useHistory();
  const {
    data: profileData
  } = useProfile();

  return (
    <nav
      className={`flex items-center border-b sticky top-0 py-2 bg-white p-0 m-0 z-30 ${containerClass}`}
    >
      {/* Title Section */}
      <div
        className={`${
          showBackButton || reDirect ? "pl-1" : "xs:px-3 md:pl-5"
        } flex md:flex-row xs:flex-col py-1 justify-between flex-1`}
      >
        {loading ? (
          <ContextItemLoadingIndicator />
        ) : (
          !hideTitleAndRedirect && (
            <div className="flex items-center ">
              {(showBackButton || reDirect) && (
                <DropDownIcon
                  height={20}
                  width={25}
                  className="rotate-90 mt-2 md:mr-3 mr-2 cursor-pointer"
                  onClick={() => (reDirect ? reDirect() : history.goBack())}
                />
              )}
              <CustomText
                text={title}
                fontWeight="font-semibold"
                fontSize="md:text-base text-xs"
                className={`${
                  hideSubHeaderSelectors ? "" : "md:mb-0 mb-2"
                } md:w-auto truncate max-w-[70vw] md:max-w-none`}
              />
            </div>
          )
        )}
        {!loading && !hideSubHeaderSelectors && (
          <Selectors className="flex md:hidden " profile={profileData} />
        )}
      </div>

      {/* Buttons Section */}
      {customButtons && (
        <div
          className={`${
            showButtonInSubheaderForMobile
              ? `flex items-center flex-row flex-nowrap gap-2 ml-auto
              ${title.includes("Online Order") ? "h-[57px] py-3" : ""} 
              md:h-auto md:gap-0 md:overflow-visible`
              : "hidden"
          } md:flex`}
        >
          {customButtons?.map((button, index) => (
            <div
              key={button.textInformation.text + index}
              className="shrink-0 flex items-center"
            >
              <Button {...button} />
              {title?.includes("Online Order") && (
                <Divider className="block md:hidden" />
              )}
            </div>
          ))}
        </div>
      )}
    </nav>
  );
}

export default SubHeader;
